/**
 * Stable CSS class names for E2E — Product comments / Comment ticket (tag) management.
 */
export const CT = {
    page: 'product-comments-comment-ticket-page',
    breadcrumbSection: 'product-comments-comment-ticket-page__breadcrumb-section',
    layout: 'product-comments-comment-ticket-page__layout',

    addTicketSection: 'product-comments-comment-ticket-page__add-ticket-section',
    addTicketPaper: 'product-comments-comment-ticket-page-input--add-ticket-paper',
    addTicketInput: 'product-comments-comment-ticket-page-input--add-ticket-text',
    addTicketButton: 'product-comments-comment-ticket-page-input--button-add-ticket',

    dataGridSection: 'product-comments-comment-ticket-page__data-grid-section',
    dataGridWrap: 'product-comments-comment-ticket-page__data-grid-wrap',
    deleteActionCell: 'product-comments-comment-ticket-page__cell-delete-action',
    deleteIcon: 'product-comments-comment-ticket-page-input--icon-delete',
} as const;

export const ctCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

